<template>
  <v-container fluid class="exams">
    <v-card flat>
      <v-card-title>
        <p>Exam Remark</p>
        <v-spacer />
        <v-btn @click="redirectToCard" color="primary"
          >Appeal For Remarking</v-btn
        >
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-data-table
          :items="remarks"
          :sort-by="['documentDate']"
          :sort-desc="[true]"
          class="bookings"
          :headers="headers"
        >
          <template v-slot:[`item.ID`]="{ index }">
            <span>{{ index + 1 }}</span>
          </template>
          <template v-slot:[`item.programme`]="{ item }">
            <span>{{ item["programme"] }}</span>
          </template>
          <template v-slot:[`item.documentDate`]="{ item }">
            <span>{{ formatDate(item["documentDate"]) }}</span>
          </template>
          <template v-slot:[`item.session`]="{ item }">
            <span>{{ item["intakeYear"] }}, {{ item["intakeSemester"] }}</span>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <span
              ><v-icon size="12" :color="statusColor[item.status]"
                >mdi-radiobox-marked</v-icon
              >
              {{ item["status"] }}</span
            >
          </template>
          <template v-slot:[`item.amount`]="{ item }">
            <span>{{ item["amount"] | currencyFormat }}</span>
          </template>
          <!--BEGIN board actions-->
          <template v-slot:[`item.action`]="{ item }">
            <v-menu open-on-hover>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="text-capitalize links"
                  text
                  v-bind="attrs"
                  v-on="on"
                  small
                  ><v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  link
                  :to="{
                    name: 'RemarkCard',
                    params: { code: encrypt(item.no) },
                  }"
                >
                  <span class="table-exam">
                    <v-icon color="primary" size="20" class="mr-1">
                      mdi-eye
                    </v-icon>
                    View
                  </span>
                </v-list-item>
                <v-divider />
                <v-list-item
                  v-if="item.proformaDocNo !== ''"
                  link
                  :to="{
                    name: 'RemarkPayments',
                    params: { code: item.no },
                  }"
                >
                  <span class="table-exam">
                    <v-icon color="primary" size="20" class="mr-1">
                      payments
                    </v-icon>
                    Remark Proforma
                  </span>
                </v-list-item>
                <v-divider />
                <v-list-item
                  v-if="item.postedReceiptNo !== ''"
                  link
                  :to="{
                    name: 'RemarkReceipt',
                    params: { code: item.postedReceiptNo },
                  }"
                >
                  <span class="table-exam">
                    <v-icon color="primary" size="20" class="mr-1">
                      receipt
                    </v-icon>
                    Remark Receipt
                  </span>
                </v-list-item>
                <v-divider />
                <v-list-item
                  @click="deleteRemark(item)"
                  v-if="item.status === 'Open'"
                >
                  <span class="table-exam">
                    <v-icon color="deep-orange darken-1" class="mr-1"
                      >delete</v-icon
                    >
                    Delete
                  </span>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <!--END board actions-->
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import status from "@/packages/applications/status";
import { helper } from "@/packages/dashboard/utils";

export default {
  name: "RemarkList",
  data: () => ({
    headers: [
      { text: "#S/N", value: "ID", sortable: false },
      { text: "Record No.", value: "no", sortable: false },
      { text: "Applied On", value: "documentDate", sortable: false },
      { text: "Programme", value: "programme", sortable: false },
      { text: "Stage", value: "stage", sortable: false },
      { text: "Amount", value: "amount", sortable: false },
      { text: "Status", value: "status", sortable: false },
      { text: "Actions", value: "action", sortable: false },
    ],
  }),
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Remark/checkCanApplyForRemark");
      v.$store.dispatch("Remark/getExamRemarks");
    });
  },
  mounted() {},
  computed: {
    remarks() {
      return this.$store.getters["Remark/remarkGetter"]("remarks");
    },
    canApply() {
      return this.$store.getters["Remark/remarkGetter"]("canApply");
    },
    statusColor() {
      return status;
    },
  },
  methods: {
    formatDate(date) {
      return helper.getDateFormat(date);
    },
    encrypt(item) {
      return helper.encrypt(item);
    },
    redirectToCard() {
      if (!this.canApply) {
        this.$alert({
          title: "Appeal For Remarking",
          text: "Sorry, But you are not allowed to appeal for Remarking, Kindly contact kiseb Administrator",
        });
      } else {
        this.$router.push({ name: "RemarkCard" });
      }
    },
    deleteRemark(item) {
      this.$confirm.show({
        title: "Delete Remark Entry",
        text: "Are you sure you want to delete this remark entry, this action is irreversible",
        onConfirm: () => {
          this.$store.dispatch("Remark/deleteRemark", { ...item });
        },
      });
    },
  },
};
</script>

<style scoped></style>
